import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const AdvanceWithdrawPopUp = (props) => {
    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mt-[12px] pb-[10px] border-b border-slate-200 lightBlue">
                        <div className="input-outer-grp flex gap-2.5">
                            <div className="input-grp w-[40%]">
                                <label>Receipt no</label>
                                <TextInput type="number" id="receiptNo" name="receiptNo" value={props.receiptDetails.receiptNo} handleChange={(event) => props.handleChange(event, "receiptNo")} disabled />
                            </div>
                            <div className="input-grp w-[60%]">
                                <label>Date</label>
                                <TextInput type="date" id="date" name="date" value={props.receiptDetails.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Select employee</label>
                            <TextInput
                                id="authorizeBy"
                                name="authorizeBy"
                                value={props.receiptDetails.employeeName}
                                handleOnClick={(event) => props.handleOnClick(event, "authorizeBy")}
                                className={props.validState?.error?.employeeName !== undefined ? "error" : ""} 
                            />
                            {/* <SingleSelectWithSearch id="selectEmployee" name="selectEmployee" value={props.receiptDetails.selectEmployee} handleChangeTest={(event) => props.handleSelectChange(event, "selectEmployee")} className={props.validState?.error?.selectEmployee !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Acc. Sub Head</label>
                            <SingleSelectWithSearch
                                drpIdentity={"aCCSubHeadList"}
                                optionArray={props.aCCSubHeadList}
                                value={props.receiptDetails.idGeneralProduct}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.productName}
                                disabled={true}
                                // classParams={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParametersTest}
                            />
                            {/* <SingleSelectWithSearch id="accSubHead" name="accSubHead" value={props.receiptDetails.accSubHead} handleChangeTest={(event) => props.handleSelectChange(event, "accSubHead")} className={props.validState?.error?.accSubHead !== undefined ? "error" : ""} /> */}
                        </div>

                    </div>
                    <div className="item-inner grid grid-cols-[0.5fr_1.5fr_1fr_1fr] gap-2.5 mt-2.5 mb-3">
                        <div className="input-grp">
                            <label>Payment mode</label>
                            <SingleSelectWithSearch
                                drpIdentity={"PaymentMode"}
                                optionArray={props.paymentModeList}
                                value={props.receiptDetails.idPaymentMode}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.paymentMode}
                                classParams={props.validState?.error?.idPaymentMode !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParametersTest}
                            />
                            {/* <SingleSelectWithSearch id="paymentMode" name="paymentMode" value={props.receiptDetails.paymentMode} handleChangeTest={(event) => props.handleSelectChange(event, "paymentMode")} className={props.validState?.error?.paymentMode !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Select bank</label>
                            <SingleSelectWithSearch
                                drpIdentity={"selectBank"}
                                optionArray={props.bankList}
                                value={props.receiptDetails.idBank}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.bankName}
                                setFilterParameters={props.setFilterParametersTest}
                            />
                            {/* <SingleSelectWithSearch id="selectBank" name="selectBank" value={props.receiptDetails.selectBank} handleChangeTest={(event) => props.handleSelectChange(event, "selectBank")} className={props.validState?.error?.selectBank !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Select series</label>
                            <TextInput
                                id="selectSeries"
                                name="selectSeries"
                                value={props.receiptDetails.chequeBookSeries}
                                handleOnClick={(event) => props.handleOnClick(event, "selectSeries")}
                            />
                            {/* <SingleSelectWithSearch id="selectSeries" name="selectSeries" value={props.receiptDetails.selectSeries} handleChangeTest={(event) => props.handleSelectChange(event, "selectSeries")} className={props.validState?.error?.selectSeries !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch
                                //id="chequeNo"
                                name="chequeNo"
                                drpIdentity={"chequeNo"}
                                optionArray={props.chequeNoList}
                                value={props.receiptDetails.idChequeBookDetails}
                                handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")}
                                setFilterParameters={props.setFilterParametersTest}
                                searchText={props.receiptDetails.chequeNo}
                            />
                            {/* <SingleSelectWithSearch id="chequeNo" name="chequeNo" value={props.receiptDetails.chequeNo} handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")} className={props.validState?.error?.chequeNo !== undefined ? "error" : ""} /> */}
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Cheque date</label>
                            <TextInput type="date" id="chequeDate" name="chequeDate" value={props.receiptDetails.chequeDate} handleChange={(event) => props.handleChange(event, "chequeDate")} />
                        </div>
                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.receiptDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} />
                        </div>
                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput type="number" id="amount" name="amount" value={props.receiptDetails.amount} handleChange={(event) => props.handleChange(event, "amount")} className={props.validState?.error?.amount !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Balance amount</label>
                            <TextInput type="number" id="recvAmount" name="recvAmount" value={props.receiptDetails.recvAmount} handleChange={(event) => props.handleChange(event, "recvAmount")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3.5">
                        <div className="input-grp">
                            <label>Authorised by</label>
                            {/* <TextInput
                                id="authorizeBy"
                                name="authorizeBy"
                                value={props.receiptDetails.employeeName}
                                handleOnClick={(event) => props.handleOnClick(event, "authorizeBy")}

                            /> */}
                            <SingleSelectWithSearch
                                // id="authorisedBy"
                                // name="authorisedBy"
                                drpIdentity={"authorisedBy"}
                                optionArray={props.authorisedBy}
                                value={props.receiptDetails.idauthorisedBy}
                                handleChangeTest={(event) => props.handleSelectChange(event, "authorisedBy")}
                                setFilterParameters={props.setFilterParametersTest}
                                searchText={props.receiptDetails.authorisedByName}
                                classParams={props.validState?.error?.authorisedBy !== undefined ? "error" : ""} 
                            />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.receiptDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}

// export const rowData = [
//     {
//         idCashWithdraw: "CW001", srNo: 1, accountSubHead: "Cash", receiptNo: "R001", date: "2025-02-06",
//         employeeName: "John Doe", paymentMode: "Cheque", bankName: "Bank ABC", chequeBookSeries: "A1", chequeNo: "12345",
//         amount: 1000, status: "Completed"
//     },
//     {
//         idCashWithdraw: "CW002", srNo: 2, accountSubHead: "Cash", receiptNo: "R002", date: "2025-02-06",
//         employeeName: "Jane Smith", paymentMode: "Cash", bankName: "Bank XYZ", chequeBookSeries: "B2", chequeNo: "67890",
//         amount: 2000, status: "Pending"
//     },
//     {
//         idCashWithdraw: "CW003", srNo: 3, accountSubHead: "Cash", receiptNo: "R003", date: "2025-02-06",
//         employeeName: "Sam Wilson", paymentMode: "Cheque", bankName: "Bank DEF", chequeBookSeries: "C3", chequeNo: "54321",
//         amount: 1500, status: "Completed"
//     },
//     {
//         idCashWithdraw: "CW004", srNo: 4, accountSubHead: "Cash", receiptNo: "R004", date: "2025-02-06",
//         employeeName: "Alex Brown", paymentMode: "Bank Transfer", bankName: "Bank GHI", chequeBookSeries: "D4", chequeNo: "98765",
//         amount: 2500, status: "Completed"
//     },
//     {
//         idCashWithdraw: "CW005", srNo: 5, accountSubHead: "Cash", receiptNo: "R005", date: "2025-02-06",
//         employeeName: "Emily Clark", paymentMode: "Cheque", bankName: "Bank JKL", chequeBookSeries: "E5", chequeNo: "11223",
//         amount: 3000, status: "Pending"
//     }
// ];

// export const colDefs = [
//     {
//         field: "idCashWithdraw",
//         headerName: "ID Cash Withdraw",
//         width: 140,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "srNo",
//         headerName: "Sr No",
//         width: 90,
//         filter: true,
//         floatingFilter: true,
//         cellStyle: { textAlign: "center" },
//         headerClass: "ag-header-center",
//     },
//     {
//         field: "accountSubHead",
//         headerName: "Account Sub Head",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "receiptNo",
//         headerName: "Receipt No",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "date",
//         headerName: "Date",
//         width: 200,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "employeeName",
//         headerName: "Employee Name",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "paymentMode",
//         headerName: "Payment mode",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "bankName",
//         headerName: "Bank Name",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "chequeBookSeries",
//         headerName: "Cheque Book Series",
//         width: 100,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "chequeNo",
//         headerName: "ChequeNo",
//         width: 120,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "amount",
//         headerName: "Amount",
//         width: 90,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "status",
//         headerName: "Status",
//         width: 90,
//         filter: true,
//         floatingFilter: true,
//     },
// ];